// extracted by mini-css-extract-plugin
export default {"container":"ProductItem_container__+gDal","imageContainer":"ProductItem_imageContainer__vzFsV","desc":"ProductItem_desc__oYsBY"};